module.exports = __webpack_public_path__ + "img/mzxwooricard.e2553ab6.png";